import { Button } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React from "react";
import useButtonSearch from "./hooks/useButtonSearch";
import { ButtonSearchFC } from "./types";

const ButtonSearch: ButtonSearchFC = () => {
  const { isDisabled, handlerClick } = useButtonSearch();
  return (
    <Button
      disabled={isDisabled}
      onClick={handlerClick}
      fullWidth
      startIcon={<Search />}
      size={"small"}
      variant={"outlined"}
      color={"primary"}
    >
      {"Поиск"}
    </Button>
  );
};

export default ButtonSearch;
